<script setup>
import { useI18n } from 'vue-i18n';
import LaisField from 'dashboard/components-next/LaisField.vue';

defineProps({
  participants: { type: Array, default: () => [] },
  emails: { type: Object, default: () => ({}) },
  errors: { type: Object, default: () => ({}) },
  disabled: { type: Boolean, default: false },
});

const emit = defineEmits(['update']);
const { t } = useI18n();
</script>

<template>
  <div class="grid gap-4 sm:grid-cols-2">
    <LaisField
      v-for="participant in participants"
      :key="participant.id"
      :label="participant.name"
      :error="errors[`participant_${participant.id}`]"
      required
    >
      <input
        :value="emails[participant.id]"
        type="email"
        class="h-10 w-full rounded-lais-sm border border-lais-border bg-white px-3 text-sm"
        :disabled="disabled"
        @input="emit('update', participant.id, $event.target.value)"
      />
    </LaisField>
    <p v-if="!participants.length" class="text-sm text-lais-text-muted">
      {{ t('SALES.DELIVERY.EMAILS.NO_RECIPIENTS') }}
    </p>
  </div>
</template>
